import { tablet, largeDesktop } from '../../../utils/deviceWidths';

const classBuilder = ({
  containerWidth,
  shopNavOpen,
  isShop,
  isAuth,
  isPDP,
  productCatalogPageV2,
}) => {
  switch (true) {
    case containerWidth > tablet && isShop:
      switch (true) {
        case shopNavOpen && isPDP && productCatalogPageV2:
          return 'tabletLayout';
        case shopNavOpen:
          return 'tabletLayout shopNavOpen';
        case !shopNavOpen && containerWidth >= largeDesktop:
          return 'tabletShopLayout';
        default:
          return 'tabletShopLayout';
      }
    case isAuth:
      return 'plainLayout';
    default:
      return 'mobileLayout';
  }
};

export default classBuilder;
